/**
 * Side-effect: registers built-in hosted plugin pages for owlbert-web.
 * Import once from `App.tsx` before routes render.
 *
 * To add a new plugin: call {@link defineHostedPluginWeb} here (lazy `pages` map + `subroutes`).
 * For experiments, you can also use {@link registerHostedPluginWeb} at runtime (replaces built-in).
 */
import { lazy } from 'react'
import { defineHostedPluginWeb } from './hostedPluginRegistry'

defineHostedPluginWeb('meal_planning', {
  defaultSuffix: 'plans',
  subroutes: [
    { label: 'Meal plans', suffix: 'plans' },
    { label: 'Recipes', suffix: 'recipes' },
  ],
  pages: {
    plans: lazy(() => import('@owlbert/meal-planning/pages/plans')),
    recipes: lazy(() => import('@owlbert/meal-planning/pages/recipes')),
  },
})

defineHostedPluginWeb('story_writer', {
  defaultSuffix: 'story',
  subroutes: [
    { label: 'Story Writer', suffix: 'story' },
    { label: 'Story Arc', suffix: 'arc' },
    { label: 'Interactive Story', suffix: 'interactive' },
  ],
  pages: {
    story: lazy(() => import('@owlbert/storywriter/pages/storywriter').then((m) => ({ default: m.StoryWriterPage }))),
    arc: lazy(() => import('@owlbert/storywriter/pages/story_arc').then((m) => ({ default: m.StoryArcPage }))),
    interactive: lazy(() =>
      import('@owlbert/storywriter/interactive_storybuilder/pages/interactive_story').then((m) => ({
        default: m.InteractiveStoryPage,
      })),
    ),
  },
})

defineHostedPluginWeb('worldbuilder', {
  defaultSuffix: 'world',
  subroutes: [
    { label: 'World', suffix: 'world' },
    { label: 'Ideation', suffix: 'world/ideation' },
    { label: 'Populate', suffix: 'populate' },
    { label: 'Timeline', suffix: 'timeline' },
  ],
  pages: {
    world: lazy(() => import('@owlbert/worldbuilder/pages/world')),
    'world/ideation': lazy(() => import('@owlbert/worldbuilder/pages/world_ideation')),
    populate: lazy(() => import('@owlbert/worldbuilder/pages/populate')),
    timeline: lazy(() => import('@owlbert/worldbuilder/pages/timeline')),
  },
})

defineHostedPluginWeb('rpg_campaign', {
  defaultSuffix: 'campaign',
  subroutes: [
    { label: 'Campaign', suffix: 'campaign' },
    { label: 'Episodes', suffix: 'episodes' },
    { label: 'Game Systems', suffix: 'game-systems' },
  ],
  pages: {
    campaign: lazy(() => import('@owlbert/rpg-campaign/pages/campaign')),
    episodes: lazy(() => import('@owlbert/rpg-campaign/pages/episodes')),
    'game-systems': lazy(() => import('@owlbert/rpg-campaign/pages/game_systems')),
  },
})

defineHostedPluginWeb('research_assistant', {
  defaultSuffix: 'research',
  subroutes: [{ label: 'Research', suffix: 'research' }],
  pages: {
    research: lazy(() => import('@owlbert/research-assistant/pages/research')),
  },
})

defineHostedPluginWeb('blog', {
  defaultSuffix: 'blog',
  subroutes: [{ label: 'Blog', suffix: 'blog' }],
  pages: {
    blog: lazy(() => import('@owlbert/blog/pages/blog')),
  },
})
